import ResponseCode from "./ResponseCode";

export const responseCodeToMessage = (code: ResponseCode): string => {
    return map[code] || 'Wystąpił nieoczekiwany błąd';
};

const map: Record<ResponseCode, string | null> = {
    [ResponseCode.REQUEST_CANCELED]: null,
    [ResponseCode.CONNECTION_ERROR]: 'Nie można połączyć się z serwerem',
    [ResponseCode.UNDEFINED]: 'Wystąpił nieoczekiwany błąd',
    [ResponseCode.GENERAL_SERVER_ERROR]: 'Błąd serwera',
    [ResponseCode.NOT_FOUND]: 'Oferta nie została znaleziona',
    [ResponseCode.BAD_REQUEST]: 'Błędne dane',
    [ResponseCode.INVALID_DATA]: 'Nieprawidłowe dane',
    [ResponseCode.AVAILABILITY_PRICE_LOWER_THAN_COST]: 'Cena nie może być niższa niż koszt'
}
